import { Component, Input } from '@angular/core';

export interface DonutSegment { label: string; value: number; color: string; }

@Component({
  selector: 'payarc-donut',
  templateUrl: './payarc-donut.component.html',
  styleUrls: ['./payarc-donut.component.css'],
  standalone: false
})
export class PayarcDonutComponent {
  @Input() segments: DonutSegment[] = [];
  @Input() centerValue?: string;
  @Input() centerLabel?: string;
  @Input() showLegend = true;

  private readonly R = 50;

  get total(): number { return (this.segments || []).reduce((s, x) => s + (x.value || 0), 0); }

  get arcs(): { color: string; dash: number; gap: number; offset: number }[] {
    const C = 2 * Math.PI * this.R;
    const t = this.total;
    if (t <= 0) { return []; }
    let acc = 0;
    const out: { color: string; dash: number; gap: number; offset: number }[] = [];
    for (const s of this.segments) {
      if (!s.value || s.value <= 0) { continue; }
      const len = (s.value / t) * C;
      out.push({ color: s.color, dash: len, gap: C - len, offset: -acc });
      acc += len;
    }
    return out;
  }
}
